export default __webpack_public_path__ + "static/media/position_finder_not_found.149b07ec.svg";